import React from 'react';
import { InputText } from 'primereact/inputtext';

const RemindersStep = (props) => {
  const {
    formik,
    t,
    Trans,
    resetKey,
    resetReminder,
    getFormErrorMessageGraceDays,
    getFormErrorMessageReminderDays,
    business,
  } = props;

  const graceDaysPurpose = business?.purpose === 'SERVICES' ? t('plan.payment') : t('plan.donating');
  const reminderDaysPurpose = business?.purpose === 'SERVICES' ? t('plan.payment') : t('plan.donating');

  return (
    <div className="wizard-forms-wrapper p-grid p-nogutter">
      <div className="grid col-12 plan-wizard-reminders-fields">
        <div className="col-12 lg:col-6 wizard-forms">
          <label htmlFor="graceDays">
            <span className="labels">{t('plan.grace_period')}</span>
          </label>
          <div className="plan-wizard-reminder-input plan-wizard-input">
            <InputText
              key={resetKey}
              id="graceDays"
              name="graceDays"
              type="text"
              inputMode="numeric"
              value={formik.values.graceDays ?? ''}
              maxLength={2}
              onChange={(e) => {
              const value = e.target.value;
              formik.setFieldTouched('graceDays', true);
              if (value === '') {
                formik.setFieldValue('graceDays', '');
                formik.setFieldError('graceDays', '');
                return;
              }
              if (/^\d+$/.test(value) && Number(value) >= 1 && Number(value) <= 7) {
                formik.setFieldValue('graceDays', Number(value));
                formik.setFieldError('graceDays', '');
              } else {
                formik.setFieldError('graceDays', t('products.grace_days_message'));
              }
            }}
            />
          </div>
          {getFormErrorMessageGraceDays('graceDays')}
          <div style={{ marginTop: '0.7rem' }}>
            <Trans
              i18nKey="plan.graceDays_hint"
              values={{ graceDays: graceDaysPurpose }}
              components={{
                1: <span className="hints" />,
                2: <span className="bolder_hints" />,
                3: <span className="bolder_hints" />,
                4: <span className="bolder_hints" />,
                5: <span className="hints" />,
                6: <span className="bolder_hints" />,
              }}
            />
          </div>
        </div>
        <div className="col-12 lg:col-6 wizard-forms">
          <label htmlFor="reminderDays">
            <span className="labels">{t('plan.reminder')}</span>
          </label>
          <div className="plan-wizard-reminder-input plan-wizard-input">
            <InputText
              key={resetReminder}
              id="reminderDays"
              name="reminderDays"
              type="text"
              inputMode="numeric"
              value={formik.values.reminderDays ?? ''}
              maxLength={2}
              onChange={(e) => {
              const value = e.target.value;
              formik.setFieldTouched('reminderDays', true);
              if (value === '') {
                formik.setFieldValue('reminderDays', '');
                formik.setFieldError('reminderDays', '');
                return;
              }
              if (/^\d+$/.test(value) && Number(value) >= 1 && Number(value) <= 7) {
                formik.setFieldValue('reminderDays', Number(value));
                formik.setFieldError('reminderDays', '');
              } else {
                formik.setFieldError('reminderDays', t('products.reminder_days_message'));
              }
            }}
            />
          </div>
          {getFormErrorMessageReminderDays('reminderDays')}
          <div style={{ marginTop: '0.7rem' }}>
            <Trans
              i18nKey="plan.reminderDays_hint"
              values={{ reminderDays: reminderDaysPurpose }}
              components={{
                1: <span className="hints" />,
                2: <span className="bolder_hints" />,
                3: <span className="bolder_hints" />,
                4: <span className="bolder_hints" />,
                5: <span className="hints" />,
                6: <span className="bolder_hints" />,
              }}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default RemindersStep;
